import { render, staticRenderFns } from "./Wordpress01.vue?vue&type=template&id=7b35ed82&scoped=true"
import script from "./Wordpress01.vue?vue&type=script&lang=js"
export * from "./Wordpress01.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b35ed82",
  null
  
)

export default component.exports